import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package, Loader2, ShoppingBag, RotateCcw, Truck, FileText } from "lucide-react";
import api from "../../services/api";
import { OrderTimeline, TrackingCard } from "../../components/OrderTracking";

const OrdersSection = ({ onRequestReturn }) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders").then(({ data }) => setOrders(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-16"><Loader2 className="animate-spin text-[#FF3B3B]" size={32} /></div>;

  return (
    <div>
      <h1 className="font-extrabold italic uppercase tracking-tight text-slate-50 text-2xl md:text-3xl mb-5 flex items-center gap-2"><Package size={26} className="text-[#FF3B3B]" /> Mes commandes</h1>
      {orders.length === 0 ? (
        <div className="bg-[#10131A] rounded-2xl border border-[#1E232D] p-12 text-center">
          <ShoppingBag size={40} className="text-slate-500 mx-auto mb-3" />
          <p className="text-slate-400 mb-4">Vous n'avez pas encore de commande.</p>
          <Link to="/" className="btn-orange inline-block rounded-lg px-6 py-2.5 font-bold">Commencer mes achats</Link>
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.id} className="bg-[#10131A] rounded-2xl border border-[#1E232D] p-5">
              <div className="flex flex-wrap items-center justify-between gap-2 border-b border-[#1E232D] pb-3 mb-3">
                <div>
                  <span className="text-[13px] text-slate-400">Commande</span>
                  <div className="font-bold text-slate-50">#{o.id.slice(0, 8).toUpperCase()}</div>
                </div>
                <span data-testid={`order-status-badge-${o.id}`} className={`text-[13px] font-semibold px-3 py-1 rounded-full capitalize ${o.status === "annulée" ? "bg-red-950/60 text-red-300" : o.status === "livrée" ? "bg-emerald-950/60 text-emerald-400" : o.status?.includes("rembours") ? "bg-amber-950/60 text-amber-300" : "bg-[#E01F1F]/10 text-[#FF3B3B]"}`}>{o.status}</span>
                <div className="text-right">
                  <span className="text-[13px] text-slate-400">Total</span>
                  <div className="font-black text-slate-50">{o.total.toFixed(2).replace(".", ",")} €</div>
                  {o.refunded_total > 0 && <div data-testid={`order-refund-info-${o.id}`} className="text-[12px] font-semibold text-amber-300">Remboursé : {o.refunded_total.toFixed(2).replace(".", ",")} €</div>}
                </div>
              </div>
              <div className="mb-4"><OrderTimeline status={o.status} /></div>
              {o.tracking_number && <div className="mb-4"><TrackingCard order={o} /></div>}
              <div className="space-y-2">
                {o.items.map((it) => (
                  <div key={it.id} className="flex items-center gap-3">
                    <img src={it.image} alt={it.name} className="w-12 h-12 rounded-lg object-cover bg-[#08090C]" />
                    <div className="flex-1 min-w-0">
                      <div className="text-[14px] font-semibold text-slate-50 truncate">{it.name}</div>
                      <div className="text-[13px] text-slate-400">Qté {it.qty} · {it.price.toFixed(2).replace(".", ",")} €</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="flex flex-wrap items-center justify-between gap-3 mt-4 pt-3 border-t border-[#1E232D]">
                <div className="flex items-center gap-4 text-[13px] text-slate-400">
                  <span className="flex items-center gap-1.5"><Truck size={15} className="text-[#FF3B3B]" /> Livraison {o.shipping === 0 ? "offerte" : `${o.shipping.toFixed(2).replace(".", ",")} €`}</span>
                </div>
                <div className="flex items-center gap-2">
                  <a href={`/facture/${o.id}`} target="_blank" rel="noopener noreferrer" data-testid={`invoice-btn-${o.id}`} className="flex items-center gap-1.5 text-[14px] font-semibold text-slate-50 border-2 border-[#222735] rounded-lg px-3 py-2 hover:border-emerald-500 hover:text-emerald-400 transition-colors">
                    <FileText size={16} /> Facture
                  </a>
                  <button onClick={() => onRequestReturn(o)} className="flex items-center gap-1.5 text-[14px] font-semibold text-slate-50 border-2 border-[#222735] rounded-lg px-3 py-2 hover:border-[#E01F1F] hover:text-[#FF3B3B] transition-colors">
                    <RotateCcw size={16} /> Demander un retour
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default OrdersSection;
